<template>
    <v-container class="max-height">
        <v-row>
            <h1 class="text-left">Summary Report</h1>
        </v-row>
        <v-row class="py-5 d-flex justify-space-around">
            <v-col v-if="user.type === 'admin'" class="pa-0 mx-2 d-flex flex-column justify-space-between elevation-3 rounded cursor-pointer" cols="2"
                   @click="navigateTo('companies')">
                <h1 class="text-h3 py-3">
                    <v-progress-circular v-if="loading" color="primary" indeterminate/>
                    <span v-else>{{ companies }}</span>
                </h1>
                <h4 class="bg-grey-darken-1">Companies</h4>
            </v-col>
            <v-col class="pa-0 mx-2 d-flex flex-column justify-space-between elevation-3 rounded cursor-pointer" cols="2"
                   @click="navigateTo('assets')">
                <h1 class="text-h3 py-3">
                    <v-progress-circular v-if="loading" color="primary" indeterminate/>
                    <span v-else>{{ assets }}</span>
                </h1>
                <h4 class="bg-grey-darken-1">Assets</h4>
            </v-col>
            <v-col class="pa-0 mx-2 d-flex flex-column justify-space-between elevation-3 rounded cursor-pointer" cols="2"
                   @click="navigateTo('devices')">
                <h1 class="text-h3 py-3">
                    <v-progress-circular v-if="loading" color="primary" indeterminate/>
                    <span v-else>{{ devices }}</span>
                </h1>
                <h4 class="bg-grey-darken-1">Devices</h4>
            </v-col>
            <v-col class="pa-0 mx-2 d-flex flex-column justify-space-between elevation-3 rounded cursor-pointer" cols="2"
                   @click="navigateTo('drivers')">
                <h1 class="text-h3 py-3">
                    <v-progress-circular v-if="loading" color="primary" indeterminate/>
                    <span v-else>{{ drivers }}</span>
                </h1>
                <h4 class="bg-grey-darken-1">Drivers</h4>
            </v-col>
        </v-row>

        <v-row class="mt-5">
            <h1>Trips Count</h1>
        </v-row>
        <v-row>
            <v-col v-if="user.type === 'admin'" cols="12" md="3" sm="6">
                <company-select v-model="formData['company']" :items="companiesList" density="compact" label="Select Company"
                          @update:model-value="()=>{resetForm();fetchDriversList();}"/>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-select v-model="formData['driver']" :items="driversList" clearable
                          density="compact" :item-title="d => `${d.first_name || ''} ${d.last_name || ''}`.trim()" item-value="id" label="Select Driver"
                          @update:model-value="fetchReport()"/>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-select v-model="formData['days']"
                          :items="[{title:'Last 7 Days','value':7},{title:'Last 15 Days','value':15},{title:'Last 30 Days','value':30},]"
                          clearable density="compact"
                          label="Select Days"
                          @update:model-value="fetchReport()"/>
            </v-col>
        </v-row>

        <v-row class="w-100 d-flex justify-space-around">
            <v-col class="pa-0 mx-2 elevation-3 rounded" cols="6">
                <h1 class="text-h2 py-3">{{ trips }}</h1>
                <h3 class="bg-grey-darken-1">Trips</h3>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useNavigation} from "@/composables/globals";
import {useSnackbarStore} from "@/stores/snackBarStore";
import CompanySelect from "@/components/globals/company-select.vue";

const trips = ref(0);
const assets = ref(0);
const devices = ref(0);
const drivers = ref(0);
const companies = ref(0);
const loading = ref(true);
const {user} = useAuthStore();
const driversList = ref([]);
const companiesList = ref([]);
const {navigateTo} = useNavigation();
const {showSnackbar} = useSnackbarStore();
const formData = reactive({
    days: null,
    driver: null,
    company: ref(user.type !== 'admin' ? user.company.id : null),
})

onMounted(() => {
    fetchSummary();
    if (user.type === 'admin') {
        fetchCompaniesList();
    } else {
        fetchReport();
        fetchDriversList();
    }
})
const resetForm = () => {
    formData['driver'] = null;
    fetchReport();
}
const fetchSummary = () => {
    send('get', `reports/summary`)
        .then((response) => {
            assets.value = response.data.data.assets;
            devices.value = response.data.data.devices;
            drivers.value = response.data.data.drivers;
            companies.value = response.data.data.companies;
            loading.value = false;
        })
        .catch((error) => {
            loading.value = false;
            showSnackbar('Summary report could not be loaded', 'error')
        })
}
const fetchCompaniesList = () => {
    send('get', `companies/list`)
        .then((response) => {
            companiesList.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Companies List could not be loaded', 'error')
        })
}
const fetchDriversList = () => {
    send('get', `companies/drivers?list=true`, {company: formData['company']})
        .then((response) => {
            driversList.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Drivers List could not be loaded', 'error')
        })
}
const fetchReport = () => {
    send('get', `reports/trips-count`, formData)
        .then((response) => {
            trips.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Trips count could not be loaded', 'error')
        })
}
</script>
